const C = {
  name: "WarningCircle",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 7V13H11V7H13Z" fill="currentColor"/>
<path d="M12 17.25C12.69 17.25 13.25 16.69 13.25 16C13.25 15.31 12.69 14.75 12 14.75C11.31 14.75 10.75 15.31 10.75 16C10.75 16.69 11.31 17.25 12 17.25Z" fill="currentColor"/>
<path d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as WarningCircle
};
